import { Body, Button, Column, Head, Html, Img, Link, Preview, Row, Section, Text } from '@react-email/components';
import api from '../../entities/api';

const EmailTemplate = ({ ids }) => {
  const momentsLink = 'https://moments.forma.ru';
  const emailLogo = `${momentsLink}/email-logo.png`;
  const emailLoad = `${momentsLink}/email-load.png`;

  return (
    <Html lang='ru' dir='ltr'>
      <Head />
      <Preview>Планировки Moments</Preview>

      <Body style={main}>
        <Section>
          <Row style={{ marginBottom: '16px' }}>
            <Column>
              <Text style={{ ...heading, verticalAlign: 'top', whiteSpace: 'nowrap' }}>Уважаемый клиент!</Text>
            </Column>

            <Column style={{ textAlign: 'right' }}>
              <Link href={momentsLink} style={link}>
                moments.forma.ru
              </Link>
              <Link style={{ ...paragraph, paddingTop: '8px', width: '100%', display: 'inline-block' }}>
                +7 495 182 65 28
              </Link>
            </Column>
          </Row>
          <Row>
            <Text style={{ ...paragraph }}>Во вложении этого письма находятся планировки,</Text>
          </Row>
          <Row style={{ marginBottom: '60px' }}>
            <Text style={{ ...paragraph, display: 'inline' }}>находящиеся у Вас в избранном на сайте</Text>
            <Link style={{ ...link, marginLeft: '5px' }}>moments.forma.ru</Link>
          </Row>

          <Row>
            <Button
              href={`${api.urlPdf}/flats.pdf?ids=${ids}`}
              target='_blank'
              rel='noreferrer'
              style={{ ...button, marginRight: '30px', marginBottom: '20px' }}
            >
              Скачать
              <Img src={`${emailLoad}`} style={{ ...arrowIcon }} alt={'arrow'} />
            </Button>
            <Button href={momentsLink} target='_blank' rel='noreferrer' style={{ ...button }}>
              Перейти на сайт
            </Button>
          </Row>
        </Section>

        <table width='100%' cellPadding='0' cellSpacing='0' style={{ height: '50%' }}>
          <tr>
            <td>&nbsp;</td>
          </tr>
        </table>

        <Section>
          <Row>
            <Column style={{ width: '100%' }}>
              <Row style={{ marginBottom: '20px' }}>
                <Text style={paragraph}>С уважением, команда FORMA</Text>
              </Row>
              <Img src={`${emailLogo}`} alt='logo' style={logoIcon} />
            </Column>

            <Column style={{ verticalAlign: 'bottom', textAlign: 'right', width: '100%' }}>
              <Text
                style={{
                  ...paragraph,
                  verticalAlign: 'bottom',
                  textWrap: 'nowrap',
                  whiteSpace: 'nowrap',
                  width: '100%',
                }}
              >
                Служба поддержки
              </Text>
            </Column>
          </Row>
        </Section>
      </Body>
    </Html>
  );
};

export default EmailTemplate;

const main = {
  backgroundColor: '#F1F1F1',
  fontFamily: "'Halvar Mittelschrift', 'Helvetica', 'Roboto', sans-serif",
  maxWidth: '760px',
  height: '870px',
  padding: '30px',
};

const heading = {
  color: '#302E2D',
  fontSize: 40,
  fontWeight: 500,
  lineHeight: '46.32px',
  fontFamily: "'Halvar Breitschrift', 'Helvetica', 'Roboto', sans-serif",
  margin: 0,
};

const paragraph = {
  margin: 0,
  color: '#393D46',
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: '25.2px',
};

const link = {
  textDecoration: 'none',
  margin: 0,
  color: '#393D46',
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: '25.2px',
  display: 'inline',
};

const button = {
  color: '#141D27',
  background: 'transparent',
  borderRadius: '50px',
  border: '1px solid #C4C4C4',
  fontSize: '16px',
  fontWeight: 300,
  lineHeight: '19.2px',
  textAlign: 'center',
  padding: '26px 40px',
  textTransform: 'uppercase',
};

const arrowIcon = {
  width: '13.79px',
  height: '17.24px',
  marginLeft: '10px',
  display: 'inline',
  verticalAlign: 'middle',
};

const logoIcon = {
  width: '100%',
  maxWidth: '343px',
};
